const $ = jQuery;
const configDatePicker = {
	locale: $('html').attr('lang') == 'sr-RS' ? 'sr' : 'en',
   disableMobile: "true"
};
const Form = {
	addIconToDatepicker: ($wrapper) => {
		const $input = $wrapper.find('input').first();

		// Prevent duplicate initialization
		if (!$input.length || $input[0]._flatpickr) {
			return;
		}

		// Add calendar trigger if it doesn't exist
		if (!$wrapper.find('.mbn-datepicker-trigger').length) {
			$wrapper.append(`
                    <span
                        class="mbn-datepicker-trigger"
                        aria-label="Open calendar"
                    >
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.3333 1.66675V5.00008M6.66667 1.66675V5.00008M2.5 8.33341H17.5M4.16667 3.33341H15.8333C16.7538 3.33341 17.5 4.07961 17.5 5.00008V16.6667C17.5 17.5872 16.7538 18.3334 15.8333 18.3334H4.16667C3.24619 18.3334 2.5 17.5872 2.5 16.6667V5.00008C2.5 4.07961 3.24619 3.33341 4.16667 3.33341Z" stroke="#757575" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                    </span>
                `);
		}

		// Initialize Flatpickr
		const flatpickrInstance = $input.flatpickr(configDatePicker);

		// Open calendar on icon click
		$wrapper
			.find('.mbn-datepicker-trigger')
			.off('click.flatpickr')
			.on('click.flatpickr', function () {
				flatpickrInstance.open();
			});
	},
	newInitFlatpickr: () => {
		const inputs = $('.mbn-datepicker-wrapper input');
		inputs.each(function () {
			const $wrapper = $(this).parent();
			Form.addIconToDatepicker($wrapper);
		});
	},
	showFileName: () => {
		const inputs = $('input[type="file"]');
		inputs.on('change', function () {
			const $this = $(this);
			const parent = $this.parent();
			const choosenFile = parent.find('.chosen-file');
			if (this.files && this.files.length > 0) {
				console.log(this.files[0].name);
				console.log(this.files);

				let names = [];
				for (let index = 0; index < this.files.length; index++) {
					const fileData = this.files[index];
					names.push(fileData.name);
				}
				parent.addClass('has-files');
				if (choosenFile.length > 0) {
					$(choosenFile).text(names.join(', '));
				} else {
					parent.append(
						'<span class="chosen-file">' + names.join(', ') + '</span>',
					);
				}
			} else {
				parent.removeClass('has-files');
				const choosenFile = parent.find('.chosen-file');
				choosenFile.text('');
			}
		});
	},
	addNewItem: () => {
		$('.add-new-item').on('click', function (e) {
			e.preventDefault();
			const $this = $(this);
			const parent = $this.parent();
			const container = parent.prev();
			const items = container.find('.gfield_list_group');
			const lastItem = items.last();
			const addBtn = lastItem.find('.add_list_item');
			if (addBtn) {
				addBtn.trigger('click');
			}
		});
	},
	init: () => {
		Form.addNewItem();
		// Date picker
		Form.newInitFlatpickr();
		gform.addAction('gform_list_post_item_add', function (item, container) {
			// 'item' is the jQuery object of the new <tr> row
			// 'container' is the jQuery object of the <table>
			const newFields = $(item).find('.mbn-datepicker-wrapper input');
			newFields.each(function () {
				const $wrapper = $(this).parent();
				Form.addIconToDatepicker($wrapper);
			});
		});
		// show file name in field
		Form.showFileName();
	},
};
export default Form;
